import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import SearchPage from "@/pages/SearchPage";
import MyCollections from "@/pages/MyCollections";
import CollectionEditor from "@/pages/CollectionEditor";
import CollectionDetailPublic from "@/pages/CollectionDetailPublic";
import AdminDashboard from "@/pages/AdminDashboard";
import CuratorProfile from "@/pages/CuratorProfile";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/collections" element={<MyCollections />} />
      <Route path="/collections/:id" element={<CollectionEditor />} />
      <Route path="/c/:id" element={<CollectionDetailPublic />} />
      <Route path="/curator/:ownerId" element={<CuratorProfile />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
